"use strict";

exports.__esModule = true;
exports.YAxisFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _helper = require("../../Widgets/MeasureChart/helper");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var YAxisFields = exports.YAxisFields = function YAxisFields(props) {
  var _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_helper.Well, null, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("Axes.yaxis.label", "Y Axis")), children);
};